//# sourceMappingURL=unordered-list.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/list/unordered-list.interface.js
// module id = 1178
// module chunks = 4